import React from 'react';
import { UPLOADED_FILE_ALLOWED_EXTENSIONS } from '@gtintel/platform-constants';
import { CustomExcel, CustomFolder, CustomImage, CustomPDF, CustomPPT, CustomWord, CustomZip } from './styles';
const extensionToIcon = {
  '7z': <CustomZip />,
  csv: <CustomExcel />,
  doc: <CustomWord />,
  docx: <CustomWord />,
  jpeg: <CustomImage />,
  jpg: <CustomImage />,
  pdf: <CustomPDF />,
  png: <CustomImage />,
  ppt: <CustomPPT />,
  pptx: <CustomPPT />,
  rar: <CustomZip />,
  xls: <CustomExcel />,
  xlsx: <CustomExcel data-testid="excel-doc" />,
  zip: <CustomZip />
};

// Coherence check. If we add any new allowed file types we need to update <TableIcon>.
const these = Object.keys(extensionToIcon).sort();
const those = UPLOADED_FILE_ALLOWED_EXTENSIONS.sort();
if (JSON.stringify(these) !== JSON.stringify(those)) {
  throw Error('missing file extension. <TableIcon> needs updating.');
}
export default function TableIcon({
  file,
  setPath
}) {
  return {
    '7z': <CustomZip />,
    csv: <CustomExcel />,
    doc: <CustomWord />,
    docx: <CustomWord />,
    jpeg: <CustomImage />,
    jpg: <CustomImage />,
    pdf: <CustomPDF />,
    png: <CustomImage />,
    ppt: <CustomPPT />,
    pptx: <CustomPPT />,
    rar: <CustomZip />,
    xls: <CustomExcel />,
    xlsx: <CustomExcel data-testid="excel-doc" />,
    zip: <CustomZip />,
    folder: <CustomFolder data-testid="folder-doc" onClick={() => setPath(file.path)} />
  }[file.extension.toLowerCase()];
}